export class StarsSectorTrack {
    constructor(trackId) {
        this.trackId = trackId;
    }
    trackId;
    showSdb = false;
    highlight = false;
    pointouts = [];
    dbType = "LDB";
    acknowledgedAfterHandoff = true;
    // null to use default
    leaderDir = null;
    manualShowPtl = false;
    coneLength = null;
    haloRadius = null;
}
export class StarsQuicklookedSectorTrack extends StarsSectorTrack {
}
//# sourceMappingURL=starsSectorTrack.js.map